import { CSSProperties, useRef } from "react";
import { getOptimizedUrl } from "./getOptimizedUrl";

export function Image(props: {
  src: string;
  alt?: string;
  width: number;
  height: number;
  className?: string;
  style?: CSSProperties;
  optimize?: boolean;
  onResolvedSize?: (dimensions: { naturalWidth: number; naturalHeight: number }) => void;
}) {
  const ref = useRef<HTMLImageElement | null>(null);
  const { src, alt, optimize, ...imgProps } = props;
  return (
    <img
      {...imgProps}
      src={optimize ? getOptimizedUrl(props) : src}
      alt={alt ?? ""}
      ref={ref}
      onLoad={() => {
        const imageEl = ref.current;

        if (props.onResolvedSize && imageEl) {
          props.onResolvedSize({
            naturalWidth: imageEl.naturalWidth,
            naturalHeight: imageEl.naturalHeight,
          });
        }
      }}
    />
  );
}
